import React, { useEffect, useRef, useState, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router"
import ClassNames from "classnames"
import { indexOf, get, map } from "lodash"
import ReactResizeDetector from "react-resize-detector"

import { updatePausePush } from "redux/ducks/Push"
import { MAIN_ROUTES } from "routes/routes"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"
import MainMenu from "components/organisms/links/mainMenu"
import { Labels } from "components/atoms/input/input"
import { Ticker } from "components/molecules/ticker"
import { SearchDetail } from "components/utils/search"

import { HamburgerButton } from "components/atoms/btn"
import { changeThemeFunction } from "utils/util"
import { CoverBackGround } from "components/atoms/utils"
import { APIResponse } from "redux/apis/types"
import { SubMenuList } from "components/molecules/list/subMenuList"
import SpHamburgerMenu from "components/molecules/list/spMenuList"
import { TimeTableModal } from "components/organisms/modals/timetable"
import { MARKET_CONDITIONS_REPORT_URL, MANUAL_URL } from "config/const"
import { changeColor } from "redux/ducks/Setting"
import { LoadStateType, pageLoad } from "redux/ducks/PageLoad"
import {
  open_chart,
  open_symbol_detail,
  checkIsSp,
  checkParentWindow,
} from "utils/util"
import { useChangeMenuTrigger } from "components/actions/customHook/changeMenu"
import dayjs from "dayjs"

export type HeaderType = {
  children?: React.ReactNode
  path: string
}

export const nonShowHeaderPath = ["/login"]

const executeSearchAction = (data: APIResponse.Res) =>
  store.dispatch(showSymbol(data))

const colorTypeList = [{ name: "黒", id: 0 }, { name: "白", id: 1 }]
export const loadTypeList = [{ name: "自動", id: 0 }, { name: "手動", id: 1 }]

export const useHeader = (props: any): any => {
  const [openHamburger, toggleHamburger] = useState<boolean>(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const [isAutoLoad, changeLoad] = useState<number>(loadTypeList[0].id)
  const [colorType, changeColorType] = useState<number>(colorTypeList[0].id)
  const currentColorType = useRef(colorTypeList[0].id)

  useEffect(() => {
    store.dispatch(updatePausePush(isAutoLoad === 1))
  }, [isAutoLoad])

  useEffect(() => {
    ;(async () => {
      if (colorType !== currentColorType.current) {
        currentColorType.current = colorType
        await dispatch(changeColor())
        dispatch(changeThemeFunction())
      }
    })()
  }, [colorType])

  return {
    openHamburger,
    toggleHamburger,
    colorType,
    changeColorType,
    isAutoLoad,
    history,
    changeLoad,
  }
}

const Header: React.FC<HeaderType> = (props: any) => {
  const {
    openHamburger,
    toggleHamburger,
    colorType,
    changeColorType,
    isAutoLoad,
    history,
    changeLoad,
  } = useHeader(props)
  const isSp = useMemo(() => {
    return checkIsSp()
  }, [])
  const buttonId = useMemo(() => {
    return {
      none: 0,
      back: 1,
      forward: 2,
      reload: 3,
    }
  }, [])

  const dispatch = useDispatch()
  const [modalTimeTable, displayTimeTable] = useState(false)
  const [activeMoveButton, setActiveMoveButton] = useState<number>(
    buttonId.none
  )
  const [focusEffect, setFocusEffect] = useState(false)
  const isLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )
  const { _changeMenuTrigger } = useChangeMenuTrigger()

  const htmlClass = document.querySelector("html").classList
  const bodyClass = document.querySelector("body").classList
  useEffect(() => {
    if (openHamburger) {
      htmlClass.add("open-menu")
      bodyClass.add("open-menu")
    } else {
      htmlClass.remove("open-menu")
      bodyClass.remove("open-menu")
    }
  }, [openHamburger])

  useEffect(() => {
    if (focusEffect) {
      setFocusEffect(false)
      setTimeout(() => {
        setFocusEffect(true)
      }, 100)
    } else {
      setFocusEffect(true)
    }
  }, [history.location])

  const buttonList = useMemo(() => {
    return [
      { id: buttonId.back, name: "戻る", icon: "play_arrow" },
      { id: buttonId.forward, name: "次へ", icon: "play_arrow" },
    ]
  }, [])

  const reloadTime = useMemo(() => {
    return dayjs().format("MM/DD HH:mm:ss")
  }, [isLoading, _changeMenuTrigger.changeMenuFlag, history.location])

  const subMenuList = [
    {
      icon: "color_lens",
      cls: "",
      name: "テーマ切替",
      onClick: async () => {
        await dispatch(changeColor())
        dispatch(changeThemeFunction())
      },
    },
    {
      icon: "list_alt",
      cls: "",
      name: "取引時間",
      onClick: () => displayTimeTable(true),
    },
    {
      icon: "library_books",
      cls: "",
      name: "銘柄リスト",
      onClick: () =>
        window.open(
          "./#/symbol/four_half",
          "four_half",
          "width=1200, height=945"
        ),
    },
    {
      icon: "",
      cls: "",
      name: "チャート",
      iconSvg: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="#f7f6e8"
          width="18px"
          height="18px"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
        </svg>
      ),
      onClick: () => open_chart({}, {}),
    },
    {
      icon: "library_books",
      cls: "",
      name: "市況レポート",
      onClick: () => {
        window.open(MARKET_CONDITIONS_REPORT_URL)
      },
    },
    {
      icon: "help_outline",
      cls: "",
      name: "マニュアル",
      onClick: () => {},
    },
  ]

  const isNonShow = indexOf(nonShowHeaderPath, props.path) >= 0
  if (isNonShow) return null

  return (
    <ReactResizeDetector
      handleWidth={true}
      render={({ width }) => {
        const isSpWindowSize = width < 769
        return (
          <>
            <header>
              <div>
                <div className="header-content">
                  <div
                    className="brand-lockup"
                    onClick={() => history.push("/top")}
                  />
                  {!isSpWindowSize && (
                    <>
                      <SearchDetail
                        className="search-bar"
                        placeholder="銘柄コード/銘柄名"
                        executeFunction={(obj: APIResponse.Res) => {
                          executeSearchAction(obj)
                          if (!isSp) open_symbol_detail(obj)
                        }}
                        forceActive={true}
                        isDirect={true}
                        inputId="search-header"
                        focusEffect={focusEffect}
                        setFocusEffect={setFocusEffect}
                      />
                      <Ticker history={history} />
                    </>
                  )}
                </div>
                {!isSpWindowSize && (
                  <div className="header-content">
                    {map(
                      buttonList,
                      (content: { id: number; name: string; icon: string }) => {
                        return (
                          <>
                            <div
                              className={ClassNames("btn btn-outline", {
                                active: activeMoveButton === content.id,
                                back: content.id === buttonId.back,
                                forward: content.id === buttonId.forward,
                              })}
                              onMouseOver={() =>
                                setActiveMoveButton(content.id)
                              }
                              onMouseLeave={() =>
                                setActiveMoveButton(buttonId.none)
                              }
                              onClick={() => {
                                if (content.id === buttonId.back) {
                                  history.goBack()
                                }
                                if (content.id === buttonId.forward) {
                                  history.goForward()
                                }
                              }}
                            >
                              {content.id === buttonId.back && (
                                <>
                                  <i className="material-icons back">
                                    {content.icon}
                                  </i>
                                  <span className="btn-text back">
                                    {content.name}
                                  </span>
                                </>
                              )}
                              {content.id === buttonId.forward && (
                                <>
                                  <span className="btn-text forward">
                                    {content.name}
                                  </span>
                                  <i className="material-icons forward">
                                    {content.icon}
                                  </i>
                                </>
                              )}
                            </div>
                          </>
                        )
                      }
                    )}
                    <SubMenuList cls="header-nav" list={subMenuList} />
                    <div
                      className={ClassNames("btn btn-outline reload", {
                        active: activeMoveButton === buttonId.reload,
                      })}
                      onMouseOver={() => setActiveMoveButton(buttonId.reload)}
                      onMouseLeave={() => setActiveMoveButton(buttonId.none)}
                    >
                      <i
                        className={ClassNames("material-icons", {
                          "is-loading": isLoading,
                        })}
                        onClick={() => store.dispatch(pageLoad())}
                      >
                        autorenew
                      </i>
                    </div>
                    <div className="btn-text reload">
                      <span className="time-text">更新日時</span>
                      <span className="time-col">{reloadTime}</span>
                    </div>
                  </div>
                )}
              </div>
              <HamburgerButton
                isClose={openHamburger}
                onClick={() => toggleHamburger(!openHamburger)}
              />
              <CoverBackGround
                active={openHamburger}
                setActive={() => toggleHamburger(false)}
                targetCls="body"
              />
              {isSpWindowSize ? (
                <SearchDetail
                  className="search-bar"
                  placeholder="銘柄コード/銘柄名"
                  executeFunction={(obj: APIResponse.Res) =>
                    executeSearchAction(obj)
                  }
                  forceActive={isSpWindowSize && !openHamburger}
                  inputId="search-header-sp"
                />
              ) : null}
              {/*{!isSpWindowSize ? (*/}
              {/*  <div className="header-content">*/}
              {/*    <Ticker />*/}
              {/*    <SubMenuList cls="header-nav" list={subMenuList} />*/}
              {/*  </div>*/}
              {/*) : null}*/}
              <div className="header-sp-load">
                <div
                  className={ClassNames("material-icons", {
                    "auto-loading": !isAutoLoad,
                    "is-loading": isLoading,
                  })}
                  onClick={() => store.dispatch(pageLoad())}
                >
                  autorenew
                </div>
              </div>
              <div
                className={ClassNames("sp-menu", { "is-open": openHamburger })}
              >
                {/* <ul>
                  <li>
                    <div className="title-border">テーマ切替</div>
                    <div>
                      <Labels
                        className="btn-segmented-control btn-thin liquid-control"
                        labelList={colorTypeList}
                        checked={colorType}
                        onChange={(id: number) => changeColorType(id)}
                      />
                    </div>
                  </li>
                  <li>
                    <div className="title-border">ページ更新</div>
                    <div>
                      <Labels
                        className="btn-segmented-control btn-thin liquid-control"
                        labelList={loadTypeList}
                        checked={isAutoLoad}
                        onChange={(id: number) => {
                          changeLoad(id)
                        }}
                      />
                    </div>
                  </li>
                  <li
                    onClick={() => {
                      window.open(MARKET_CONDITIONS_REPORT_URL)
                    }}
                  >
                    <div className="btn btn-primary">市況レポート</div>
                  </li>
                  <li
                    onClick={() => {
                      window.open(MANUAL_URL)
                    }}
                  >
                    <div className="btn btn-primary">マニュアル</div>
                  </li>
                </ul> */}
                <SpHamburgerMenu
                  visible={openHamburger}
                  setVisible={() => toggleHamburger(false)}
                  colorType={colorType}
                  changeColorType={changeColorType}
                  isAutoLoad={isAutoLoad}
                  changeLoad={changeLoad}
                  location={get(props, "path")}
                />
                <div className="sp-menu-bottom-btn-row">
                  <div
                    className="btn btn-outline ripple"
                    data-izimodal-close="true"
                    onClick={() => toggleHamburger(false)}
                  >
                    閉じる
                  </div>
                </div>
              </div>
            </header>
            <div className={ClassNames("main-wrap")}>
              {props.children}
              <MainMenu route={MAIN_ROUTES} isSpWindowSize={isSpWindowSize} />
            </div>
            <TimeTableModal
              show={modalTimeTable}
              onHide={() => displayTimeTable(false)}
            />
          </>
        )
      }}
    />
  )
}

export default Header
